function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.26,11.22l0,0v.62a13.64,13.64,0,0,1-21,11.5,5.47,5.47,0,0,1,1.13.08,9.65,9.65,0,0,0,6-2.07A4.82,4.82,0,0,1,6.92,18a5.08,5.08,0,0,0,2.16-.09,4.78,4.78,0,0,1-3.84-4.7,4.81,4.81,0,0,0,2.17.58A4.79,4.79,0,0,1,5.92,7.4a13.67,13.67,0,0,0,9.88,5A4.79,4.79,0,0,1,24,8a9.49,9.49,0,0,0,3.12-1.2A4.91,4.91,0,0,1,25,9.49a10,10,0,0,0,2.75-.75A9.63,9.63,0,0,1,25.26,11.22Z",
    style: {
      fill: "#55acee"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ff590956.svg";
export { ForwardRef as ReactComponent };